import React from 'react';
import { CTAButton } from './CTAButton';
export function Guarantee() {
  return <section className="border-y border-sage/30 bg-cream-dark px-4 py-8" data-id="element-73" data-mp="1o3x4frz4v04n">
      <div className="mx-auto max-w-2xl text-center" data-id="element-74" data-mp="1o5q4gof8qm3o">
        <h2 className="font-display text-2xl font-black uppercase leading-tight sm:text-3xl" data-id="element-75" data-mp="222dcbm8qewod">
          Il tuo acquisto è protetto al 100%
        </h2>
        <div className="mt-3 rounded-2xl border-2 border-sage bg-white p-4 sm:p-6" data-id="element-76" data-mp="1x2iltjsvc93u">
          <h3 className="font-display text-base font-extrabold uppercase leading-tight sm:text-xl" data-id="element-77" data-mp="19co8l14n0ij2">
            🛡️ Garanzia Soddisfatti o Rimborsati di 14 Giorni
          </h3>
          <div className="mt-2 space-y-1 text-[15px] leading-snug text-graphite sm:text-base" data-id="element-78" data-mp="1j652s68orzn9">
            <p data-id="element-79" data-mp="1ed28fvw34m60">Il tuo acquisto è completamente senza rischi.</p>
            <p data-id="element-80" data-mp="qnpxorl4061l">
              Hai 14 giorni per esplorare i moduli e utilizzare attività, sessioni, percorsi,
              strumenti di pianificazione e materiali professionali inclusi in LOGOPEDIA PRO™.
            </p>
            <p data-id="element-81" data-mp="oygoin5pjsei">
              Se per qualsiasi motivo non sarai completamente soddisfatto, ti basterà contattarci
              entro 14 giorni e riceverai il rimborso completo.
            </p>
            <p className="font-semibold text-petrol" data-id="element-82" data-mp="yqdzbsst0icp">Nessun rischio.</p>
            <p className="font-semibold text-petrol" data-id="element-83" data-mp="12qoenw2hkl48">Nessuna domanda.</p>
          </div>
        </div>
        <CTAButton className="mx-auto mt-4 max-w-lg" data-id="element-84" data-mp="60xat68b1llr" />
      </div>
    </section>;
}